module.exports = __webpack_public_path__ + "img/filter-reset.8ee2108.svg";